<section class="content">
    <h1>Processo de remoção de conta</h1>
    <h4 class="topMargin">Aplicativo: Velocity</h4>
    <div class="conditions">
        <h4>Condições para exclusão da conta</h4>
            <p>- Por motivos fiscais, você só pode solicitar exclusão da sua conta após 365 dias da sua última compra;</p>
            <p>- Por motivos jurídicos, você só pode solicitar exclusão da sua conta após 365 dias da última prestação de serviço;</p>
            <p>- Você não pode ter pendências financeiras;</p>
    </div>
    <div class="conditions">
        <h4>Quais dados serão removidos?</h4>
            <p>- Se cumprir todos esses requisitos os seus dados pessoais que permitem sua identificação serão anonimizados. Os dados são nome, email, cpf ou passaporte, telefone, endereço, data de nascimento, gênero;</p>
            <p>- Registros de compras e serviços prestados continuarão no sistema, porém não haverá como vinculá-los a você;</p>
            <p>- Esta ação é irreversível e mesmo a equipe técnica não será capaz de revertê-la.</p>
    </div>
    <ng-container *ngFor="let item of data; let i = index">
        <div>
            <h4 class="title"><div class="number">{{i + 1}}</div>{{item.title}}</h4>
            <p>{{item.description}}</p>
            <div class="center">
                <img src="../../../../../assets/velocity/{{i + 1}}.webp" />
            </div>
        </div>
    </ng-container>
    
</section>